class Slider {
  constructor(slider) {
    this.slider = slider;
    this.track = slider.querySelector(".slider-track");
    this.slides = slider.querySelectorAll(".slide");

    this.nextBtn = slider.querySelector(".next");
    this.prevBtn = slider.querySelector(".prev");

    this.index = 0;

    this.init();
  }

  init() {
    this.nextBtn.addEventListener("click", () => this.next());
    this.prevBtn.addEventListener("click", () => this.prev());

    this.update();
  }

  update() {
    this.track.style.transform = `translateX(-${this.index * 100}%)`;
  }

  next() {
    this.index = (this.index + 1) % this.slides.length;
    this.update();
  }

  prev() {
    this.index = (this.index - 1 + this.slides.length) % this.slides.length;

    this.update();
  }
}

document
  .querySelectorAll("[data-type=slider]")
  .forEach((slider) => new Slider(slider));

class Carousel {
  constructor(element) {
    this.carousel = element;

    this.track = this.carousel.querySelector(".carousel-track");

    this.cards = this.carousel.querySelectorAll(".carousel-card");

    this.currentIndex = 0;

    this.gap = 20;

    this.navigationType = this.carousel.getAttribute("navigation-type");

    // Drag state
    this.isDragging = false;

    this.startX = 0;

    this.currentTranslate = 0;

    this.prevTranslate = 0;

    this.prevbtn = this.carousel.querySelector("[navigation-type=prevbtn]");
    this.nextbtn = this.carousel.querySelector("[navigation-type=nextbtn]");

    this.autoScrollInterval = null;
    this.scrollDirection = 1; // 1 = next, -1 = prev

    this.updateValues();

    this.init();
  }

  init() {
    this.prevbtn.addEventListener("click", (e) => this.prev());
    this.nextbtn.addEventListener("click", (e) => this.next());

    if (this.navigationType === "dots") {
      this.createDots();
    }

    // Mobile / Tablet
    if (window.innerWidth < 992) {
      this.addDrag();
    }

    // this.startAutoScroll();

    // Pause on hover
    this.carousel.addEventListener("mouseenter", () => {
      // this.stopAutoScroll();
    });

    this.carousel.addEventListener("mouseleave", () => {
      // this.startAutoScroll();
    });

    window.addEventListener("resize", () => {
      this.updateValues();

      this.update();
    });
  }
  updateValues() {
    this.cardWidth = this.cards[0].offsetWidth + this.gap;

    this.visibleCards = Math.round(this.carousel.offsetWidth / this.cardWidth);

    this.maxIndex = this.cards.length - this.visibleCards;

    if (this.maxIndex < 0) {
      this.maxIndex = 0;
    }
  }

  update() {
    const moveX = this.currentIndex * this.cardWidth;

    this.currentTranslate = -moveX;

    this.track.style.transition = "transform 0.3s ease";
    this.track.style.transform = `translateX(${this.currentTranslate}px)`;

    this.updateDots();
  }

  next() {
    if (this.currentIndex < this.maxIndex) {
      this.currentIndex++;

      this.update();
    } else {
      this.currentIndex = 0;
      this.update();
    }
  }

  prev() {
    if (this.currentIndex > 0) {
      this.currentIndex--;

      this.update();
    } else {
      this.currentIndex = this.maxIndex;
      this.update();
    }
  }

  createDots() {
    this.dotsWrapper = document.createElement("div");

    this.dotsWrapper.className = "carousel-dots";

    this.dots = [];

    for (let i = 0; i <= this.maxIndex; i++) {
      const dot = document.createElement("div");

      dot.className = "carousel-dot";

      if (i === 0) {
        dot.classList.add("active");
      }

      dot.addEventListener("click", () => {
        this.currentIndex = i;

        this.update();
      });

      this.dots.push(dot);

      this.dotsWrapper.appendChild(dot);
    }

    this.carousel.appendChild(this.dotsWrapper);
  }

  updateDots() {
    if (!this.dots) return;

    this.dots.forEach((dot, index) => {
      dot.classList.toggle("active", index === this.currentIndex);
    });
  }

  addDrag() {
    // Mouse
    this.track.addEventListener("mousedown", this.dragStart.bind(this));

    window.addEventListener("mousemove", this.dragMove.bind(this));

    window.addEventListener("mouseup", this.dragEnd.bind(this));

    // Touch
    this.track.addEventListener("touchstart", this.dragStart.bind(this), {
      passive: true,
    });

    window.addEventListener("touchmove", this.dragMove.bind(this), {
      passive: true,
    });

    window.addEventListener("touchend", this.dragEnd.bind(this));

    // Prevent image drag
    this.track.querySelectorAll("img").forEach((img) => {
      img.draggable = false;
    });
  }

  dragStart(event) {
    // this.stopAutoScroll();
    this.isDragging = true;

    this.track.style.transition = "none";

    this.startX = this.getPositionX(event);

    this.prevTranslate = this.currentTranslate;

    this.track.classList.add("dragging");
  }

  dragMove(event) {
    if (!this.isDragging) return;

    const currentPosition = this.getPositionX(event);

    const diff = currentPosition - this.startX;

    let newTranslate = this.prevTranslate + diff;

    // Max drag left
    const maxTranslate = -(this.maxIndex * this.cardWidth);

    // Prevent empty space left
    if (newTranslate > 0) {
      newTranslate = 0;
    }

    // Prevent empty space right
    if (newTranslate < maxTranslate) {
      newTranslate = maxTranslate;
    }

    this.currentTranslate = newTranslate;

    this.track.style.transform = `translateX(${this.currentTranslate}px)`;
  }

  dragEnd() {
    if (!this.isDragging) return;

    this.isDragging = false;

    const movedBy = this.currentTranslate - this.prevTranslate;

    // Threshold
    if (movedBy < -50) {
      this.next();
    } else if (movedBy > 50) {
      this.prev();
    } else {
      this.update();
    }

    this.track.classList.remove("dragging");
    // this.startAutoScroll();
  }

  getPositionX(event) {
    return event.type.includes("mouse")
      ? event.pageX
      : event.touches[0].clientX;
  }

  addWheelScroll() {
    let isScrolling = false;

    this.carousel.addEventListener(
      "wheel",
      (event) => {
        event.preventDefault();

        // Prevent spam scrolling
        if (isScrolling) return;

        isScrolling = true;

        if (event.deltaY > 0 || event.deltaX > 0) {
          this.next();
        } else {
          this.prev();
        }

        setTimeout(() => {
          isScrolling = false;
        }, 300);
      },
      { passive: false },
    );
  }

  startAutoScroll() {
    if (this.autoScrollInterval) return;

    this.autoScrollInterval = setInterval(() => {
      // Don't auto-scroll while dragging
      if (this.isDragging) return;

      if (this.scrollDirection === 1) {
        if (this.currentIndex < this.maxIndex) {
          this.next();
        } else {
          this.scrollDirection = -1;
          this.prev();
        }
      } else {
        if (this.currentIndex > 0) {
          this.prev();
        } else {
          this.scrollDirection = 1;
          this.next();
        }
      }
    }, 3000);
  }

  stopAutoScroll() {
    clearInterval(this.autoScrollInterval);
    this.autoScrollInterval = null;
  }
}

/* =========================
       Init All Carousels
    ========================== */
document.querySelectorAll('[data-type="carousel"]').forEach((carousel) => {
  new Carousel(carousel);
});


// product media slider ---------------------------------------------------------------

class product_media_slider {
  constructor(slider) {
    this.slider = slider;
    this.track = slider.querySelector(".media-slider-tracker");
    this.slides = [...slider.querySelectorAll(".slide")];
    this.dostContainer = slider.querySelector(".dots");
    this.prevbtn = slider.querySelector("[data-prev-btn]");
    this.nextbtn = slider.querySelector("[data-next-btn]");
    this.createDots();
    this.dots = [...slider.querySelectorAll(".dot")];

    // vertical thumbnail rail lives next to the slider, inside the gallery wrapper
    this.gallery = slider.closest("[data-media-gallery]");
    this.thumbsPane = this.gallery
      ? this.gallery.querySelector("[data-pdp-thumbs]")
      : null;
    this.thumbs = this.gallery
      ? [...this.gallery.querySelectorAll("[data-pdp-thumb]")]
      : [];

    this.isDragging = false;
    this.startX = 0;
    this.scrollLeft = 0;
    this.scrollFrame = null;
    this.activeIndex = 0;

    this.init();
  }

  init() {
    this.imageZoom();
    this.nextbtn.addEventListener("click", (e) => {
      this.next();
    });
    this.prevbtn.addEventListener("click", (e) => {
      this.prev();
    });

    this.dotNavigation();
    this.thumbNavigation();

    // keep dots and the thumbnail rail in step with swipe / native scroll too
    this.track.addEventListener("scroll", () => {
      if (this.scrollFrame) return;

      this.scrollFrame = requestAnimationFrame(() => {
        this.scrollFrame = null;
        this.setActive(this.getActiveIndex());
      });
    });
  }

  thumbNavigation() {
    this.thumbs.forEach((thumb, index) => {
      thumb.addEventListener("click", () => {
        this.goToSlide(index);
      });
    });
  }

  setActiveThumb(index) {
    if (!this.thumbs.length) return;

    this.thumbs.forEach((thumb) => {
      thumb.classList.remove("is-active");
      thumb.removeAttribute("aria-current");
    });

    const thumb = this.thumbs[index];
    if (!thumb) return;

    thumb.classList.add("is-active");
    thumb.setAttribute("aria-current", "true");
    this.revealThumb(thumb);
  }

  // scroll the rail (not the page) so the active tile stays inside the four-tile window
  revealThumb(thumb) {
    const pane = this.thumbsPane;
    if (!pane) return;

    const paneBox = pane.getBoundingClientRect();
    const thumbBox = thumb.getBoundingClientRect();

    if (pane.scrollHeight > pane.clientHeight + 1) {
      if (thumbBox.top < paneBox.top) {
        pane.scrollTo({
          top: pane.scrollTop - (paneBox.top - thumbBox.top),
          behavior: "smooth",
        });
      } else if (thumbBox.bottom > paneBox.bottom) {
        pane.scrollTo({
          top: pane.scrollTop + (thumbBox.bottom - paneBox.bottom),
          behavior: "smooth",
        });
      }
      return;
    }

    if (pane.scrollWidth > pane.clientWidth + 1) {
      if (thumbBox.left < paneBox.left) {
        pane.scrollTo({
          left: pane.scrollLeft - (paneBox.left - thumbBox.left),
          behavior: "smooth",
        });
      } else if (thumbBox.right > paneBox.right) {
        pane.scrollTo({
          left: pane.scrollLeft + (thumbBox.right - paneBox.right),
          behavior: "smooth",
        });
      }
    }
  }

  setActive(index) {
    this.setActiveDot(index);

    // skip the rail work (and its scrollTo) while the index has not actually moved
    if (index === this.activeIndex) return;

    this.activeIndex = index;
    this.setActiveThumb(index);
  }

  createDots() {
    this.slides.forEach((_, index) => {
      if (index !== 0) {
        const dot = document.createElement("button");
        dot.classList.add("dot");
        // dot.dataset.slide = index; // optional
        this.dostContainer.appendChild(dot);
      }
    });
  }

  dotNavigation() {
    this.dots.forEach((dot, index) => {
      // console.log(dot);
      dot.addEventListener("click", () => {
        const slide = this.slides[index];

        this.track.scrollTo({
          left: slide.offsetLeft,
          behavior: "smooth",
        });

        this.setActive(index);
      });
    });
  }

  goToSlide(index) {
    const slide = this.slides[index];
    if (!slide) return;

    this.track.scrollTo({
      left: slide.offsetLeft,
      behavior: "smooth",
    });

    this.setActive(index);
  }

  getActiveIndex() {
    const scrollPosition = this.track.scrollLeft;

    let activeIndex = 0;

    this.slides.forEach((slide, index) => {
      if (scrollPosition >= slide.offsetLeft - slide.clientWidth / 2) {
        activeIndex = index;
      }
    });

    return activeIndex;
  }

  updateActiveDot() {
    const scrollPosition = this.track.scrollLeft;

    let activeIndex = 0;

    this.slides.forEach((slide, index) => {
      if (scrollPosition >= slide.offsetLeft - slide.clientWidth / 2) {
        activeIndex = index;
      }
    });

    this.setActiveDot(activeIndex);
  }

  next() {
    const currentIndex = this.getActiveIndex();
    const nextIndex = Math.min(currentIndex + 1, this.slides.length - 1);

    this.goToSlide(nextIndex);
  }

  prev() {
    const currentIndex = this.getActiveIndex();
    const prevIndex = Math.max(currentIndex - 1, 0);

    this.goToSlide(prevIndex);
  }

  setActiveDot(index) {
    this.dots.forEach((dot) => {
      dot.classList.remove("active");
    });

    if (this.dots[index]) {
      this.dots[index].classList.add("active");
    }
  }

  imageZoom() {
    const isTouchDevice =
      "ontouchstart" in window || navigator.maxTouchPoints > 0;

    this.slides.forEach((img) => {
      const zoom = (clientX, clientY) => {
        const rect = img.getBoundingClientRect();

        const x = ((clientX - rect.left) / rect.width) * 100;
        const y = ((clientY - rect.top) / rect.height) * 100;

        img.style.transformOrigin = `${x}% ${y}%`;
        img.style.transform = "scale(2)";
      };

      if (isTouchDevice) {
        // Mobile / Tablet
        img.addEventListener("touchstart", (e) => {
          document.body.style.overflow = "hidden";
          const touch = e.touches[0];
          zoom(touch.clientX, touch.clientY);
        });

        img.addEventListener("touchmove", (e) => {
          const touch = e.touches[0];
          zoom(touch.clientX, touch.clientY);
        });

        img.addEventListener("touchend", () => {
          document.body.style.overflow = "";
          img.style.transform = "scale(1)";
          img.style.transformOrigin = "center";
        });
      } else {
        // Desktop
        img.addEventListener("mousemove", (e) => {
          zoom(e.clientX, e.clientY);
        });

        img.addEventListener("mouseleave", () => {
          img.style.transform = "scale(1)";
          img.style.transformOrigin = "center";
        });
      }
    });
  }
}

document
  .querySelectorAll("[data-type=product-media-images]")
  .forEach((slider) => {
    new product_media_slider(slider);
  });

// product description clamp ------------------------------------------------------------
document.querySelectorAll("[data-pdp-description]").forEach((wrapper) => {
  const body = wrapper.querySelector("[data-pdp-description-body]");
  const toggle = wrapper.querySelector("[data-pdp-description-toggle]");

  if (!body || !toggle) return;

  // only offer the toggle when the three-line clamp is actually hiding something
  const syncToggle = () => {
    if (wrapper.classList.contains("is-expanded")) return;
    toggle.hidden = body.scrollHeight <= body.clientHeight + 1;
  };

  toggle.addEventListener("click", () => {
    const expanded = wrapper.classList.toggle("is-expanded");

    toggle.textContent = expanded ? "Read less" : "Read more";
    toggle.setAttribute("aria-expanded", String(expanded));
  });

  syncToggle();

  // web fonts and a resize both change where the text wraps
  window.addEventListener("load", syncToggle);
  window.addEventListener("resize", syncToggle);
});

// flip card ---------------------------------------------------------------------------------
/*
class FlipImageCard {
  constructor(card) {
    this.card = card;

    this.init();
  }

  init() {
    this.card.addEventListener("click", () => {
      this.card.classList.toggle("active");
    });
  }
}

document.querySelectorAll('[data-type="flip-image-card"]').forEach((card) => {
  new FlipImageCard(card);
});
*/

class FlipImageCard {
  constructor(card) {
    this.card = card;

    this.init();
  }

  init() {
    this.card.addEventListener("click", () => {
      this.card.classList.toggle("active");
    });
  }

  flip() {
    this.card.classList.toggle("active");
  }
}

const cards = [];

document.querySelectorAll('[data-type="flip-image-card"]').forEach((card) => {
  cards.push(new FlipImageCard(card));
});

// Auto flip one by one (no-op on pages without flip cards)
let currentIndex = 0;

if (cards.length) {
  setInterval(() => {
    // cards.forEach((card, index) => {
    //   card.card.classList.toggle("active", index === currentIndex);
    // });
    cards[currentIndex].card.classList.toggle("active");

    currentIndex++;

    if (currentIndex >= cards.length) {
      currentIndex = 0;
    }
  }, 2000);
}

// CartDrawer--------------------------------------------------------------------------------------------------------------
class CartDrawer {
  constructor() {
    this.drawer = document.querySelector("[data-cart-drawer]");

    if (!this.drawer) return;

    this.openButtons = document.querySelectorAll("[data-cart-open]");
    this.closeButtons = document.querySelectorAll("[data-cart-close]");

    this.init();
    this.checkAutoOpen();
  }

  init() {
    this.openButtons.forEach((button) => {
      button.addEventListener("click", () => {
        this.open();
      });
    });

    this.closeButtons.forEach((button) => {
      button.addEventListener("click", () => {
        this.close();
      });
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        this.close();
      }
    });

    // ADD THIS
    // this.handleAddToCart();
  }

  open() {
    this.drawer.classList.add("is-active");
    document.body.classList.add("overflow-hidden");
  }

  close() {
    this.drawer.classList.remove("is-active");
    document.body.classList.remove("overflow-hidden");
  }
  handleAddToCart() {
    document.addEventListener("submit", async (event) => {
      const form = event.target;

      if (!form.matches('form[action*="/cart/add"]')) return;

      event.preventDefault();

      const formData = new FormData(form);

      try {
        // AJAX add to cart
        const response = await fetch("/cart/add.js", {
          method: "POST",
          body: formData,
          headers: {
            Accept: "application/json",
          },
        });

        const product = await response.json();

        //  console.log(product);

        // open cart drawer
        this.open();
      } catch (error) {
        console.error(error);
      }
    });
  }

  checkAutoOpen() {
    const shouldOpen = sessionStorage.getItem("cart-open");

    if (shouldOpen === "true") {
      this.open();

      sessionStorage.removeItem("cart-open");
    }
  }
}

new CartDrawer();

// Product From -------------------------------------------------------------------------------

class ProductForm {
  constructor(form) {
    this.form = form;

    this.form.addEventListener("submit", this.onSubmit.bind(this));
  }

  async onSubmit(event) {
    event.preventDefault();

    const formData = new FormData(this.form);

    // detect form type
    const type = this.form.dataset.type;

    // endpoint based on type
    let endpoint = "/cart/add.js";

    if (type === "update") {
      console.log("update event");

      endpoint = "/cart/update.js";
    }

    try {
      const response = await fetch(endpoint, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      console.log(data);

      // keep drawer open
      sessionStorage.setItem("cart-open", "true");

      // reload
      window.location.reload();
    } catch (error) {
      console.error(error);
    }
  }
}

document.querySelectorAll(".shopify-product-form").forEach((form) => {
  new ProductForm(form);
});

// -----------------------product Qty ProductQuantity ----------------------------------------

class ProductQuantity {
  constructor(wrapper) {
    this.wrapper = wrapper;

    this.minusBtn = wrapper.querySelector("[data-qty-minus]");

    this.plusBtn = wrapper.querySelector("[data-qty-plus]");

    this.input = wrapper.querySelector("[data-qty-value]");

    this.min = Number(this.input.min) || 1;

    this.max = Number(this.input.max) || 999;

    this.value = Number(this.input.value) || 1;

    this.init();
  }

  init() {
    this.updateInput();
    this.bindEvents();
  }

  bindEvents() {
    this.plusBtn?.addEventListener("click", () => this.increase());

    this.minusBtn?.addEventListener("click", () => this.decrease());
  }

  increase() {
    if (this.value >= this.max) return;

    this.value += 1;

    this.updateInput();
  }

  decrease() {
    if (this.value <= this.min) return;

    this.value -= 1;

    this.updateInput();
  }

  updateInput() {
    this.input.value = this.value;

    this.wrapper.setAttribute("data-current-qty", this.value);

    this.minusBtn.disabled = this.value <= this.min;

    this.plusBtn.disabled = this.value >= this.max;
  }
}

/* =========================
   INIT ALL QUANTITY
========================= */

document.querySelectorAll("[data-product-qty]").forEach((qty) => {
  new ProductQuantity(qty);
});

// ----------------------- Cart Items (update qty / remove) -----------------------

class CartItems {
  constructor(drawer) {
    this.drawer = drawer;

    // money format comes from cart-drawer.liquid (shop.money_format)
    this.moneyFormat =
      (window.theme && window.theme.moneyFormat) || "${{amount}}";

    this.bindEvents();
  }

  bindEvents() {
    // delegate so it keeps working after the DOM is updated
    this.drawer.addEventListener("click", (event) => {
      const minusBtn = event.target.closest("[data-update-qty-minus]");
      const plusBtn = event.target.closest("[data-update-qty-plus]");
      const removeBtn = event.target.closest("[data-cart-remove]");

      if (minusBtn) {
        this.changeQuantity(minusBtn, -1);
      } else if (plusBtn) {
        this.changeQuantity(plusBtn, 1);
      } else if (removeBtn) {
        this.removeItem(removeBtn);
      }
    });
  }

  changeQuantity(button, step) {
    const item = button.closest("[data-cart-item]");

    if (!item) return;

    const input = item.querySelector("[data-update-qty-value]");

    const min = Number(input.min) || 1;
    const max = Number(input.max) || 999;

    const current = Number(input.value) || 1;
    const newQty = current + step;

    // respect the input's min / max
    if (newQty < min || newQty > max) return;

    this.updateCart(item, newQty);
  }

  removeItem(button) {
    const item = button.closest("[data-cart-item]");

    if (!item) return;

    // quantity 0 removes the line from the cart
    this.updateCart(item, 0);
  }

  async updateCart(item, quantity) {
    // ignore clicks while a request is already running for this line
    if (item.classList.contains("is-loading")) return;

    item.classList.add("is-loading");

    const key = item.dataset.cartItem;

    try {
      // 1) ALWAYS call the Shopify ajax api first and wait for the response
      const response = await fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ id: key, quantity: quantity }),
      });

      const cart = await response.json();

      // 2) only update the ui after the api responds
      this.updateUI(cart, item, key, quantity);
    } catch (error) {
      console.error("Cart update failed:", error);
    } finally {
      item.classList.remove("is-loading");
    }
  }

  updateUI(cart, item, key, quantity) {
    if (quantity === 0) {
      // line removed
      item.remove();
    } else {
      // find the updated line in the response and refresh qty + line price
      const line = cart.items.find((cartItem) => cartItem.key === key);

      if (line) {
        const input = item.querySelector("[data-update-qty-value]");
        const price = item.querySelector("[data-item-price]");

        if (input) input.value = line.quantity;
        if (price) price.textContent = this.formatMoney(line.final_line_price);
      }
    }

    // total price
    const total = this.drawer.querySelector("[data-total-cart-price]");

    if (total) total.textContent = this.formatMoney(cart.total_price);

    // item count + empty state
    const count = this.drawer.querySelector("[data-cart-count]");

    if (count) {
      count.textContent = `(${cart.item_count})`;
    }

    // when the cart is empty, reload so the empty-state markup renders
    if (cart.item_count === 0) {
      window.location.reload();
    }
  }

  // Shopify-style money formatter (cents -> formatted string)
  formatMoney(cents) {
    if (typeof cents === "string") cents = cents.replace(".", "");

    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const format = this.moneyFormat;

    const formatWithDelimiters = (
      number,
      precision = 2,
      thousands = ",",
      decimal = ".",
    ) => {
      if (isNaN(number) || number == null) return "0";

      number = (number / 100).toFixed(precision);

      const parts = number.split(".");
      const dollars = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        "$1" + thousands,
      );
      const centsPart = parts[1] ? decimal + parts[1] : "";

      return dollars + centsPart;
    };

    let value = "";

    switch (format.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return format.replace(placeholderRegex, value);
  }
}

document.querySelectorAll("[data-cart-drawer]").forEach((drawer) => {
  new CartItems(drawer);
});

// ----------------------- Search Box (predictive product search) -----------------------

class SearchBox {
  constructor(root) {
    this.root = root;

    this.trigger = root.querySelector("[data-search-trigger]");
    this.form = root.querySelector("[data-search-form]");
    this.input = root.querySelector("[data-search-input]");
    this.clearBtn = root.querySelector("[data-search-clear]");
    this.results = root.querySelector("[data-search-results]");

    // endpoints / config passed in from the liquid snippet
    this.searchUrl = root.dataset.searchUrl || "/search";
    this.predictiveUrl = root.dataset.predictiveUrl || "/search/suggest.json";
    this.limit = Number(root.dataset.searchLimit) || 6;

    this.moneyFormat =
      (window.theme && window.theme.moneyFormat) || "${{amount}}";

    this.debounceTimer = null;
    this.controller = null;

    this.init();
  }

  init() {
    this.trigger.addEventListener("click", () => this.open());

    this.clearBtn.addEventListener("click", () => this.clear());

    this.input.addEventListener("input", () => this.onInput());

    this.input.addEventListener("focus", () => {
      if (this.input.value.trim()) this.showResults();
    });

    // close when clicking anywhere outside the search box
    document.addEventListener("click", (event) => {
      if (!this.root.contains(event.target)) this.close();
    });

    // close on Escape
    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") this.close();
    });
  }

  open() {
    this.root.classList.add("is-open");
    this.trigger.setAttribute("aria-expanded", "true");
    this.input.focus();
  }

  close() {
    this.root.classList.remove("is-open");
    this.trigger.setAttribute("aria-expanded", "false");
    this.hideResults();
  }

  clear() {
    this.input.value = "";
    this.updateClearState();
    this.hideResults();
    this.input.focus();
  }

  onInput() {
    this.updateClearState();

    const term = this.input.value.trim();

    clearTimeout(this.debounceTimer);

    if (!term) {
      this.hideResults();
      return;
    }

    // debounce so we don't fire a request on every keystroke
    this.debounceTimer = setTimeout(() => this.search(term), 250);
  }

  updateClearState() {
    this.root.classList.toggle("has-value", this.input.value.trim().length > 0);
  }

  async search(term) {
    // cancel any in-flight request so results never arrive out of order
    if (this.controller) this.controller.abort();
    this.controller = new AbortController();

    this.renderMessage("Searching…");

    const params = new URLSearchParams({
      q: term,
      "resources[type]": "product",
      "resources[limit]": this.limit,
      "resources[options][unavailable_products]": "last",
    });

    try {
      const response = await fetch(`${this.predictiveUrl}?${params}`, {
        signal: this.controller.signal,
        headers: { Accept: "application/json" },
      });

      const data = await response.json();
      const products = data.resources?.results?.products || [];

      this.renderResults(products, term);
    } catch (error) {
      // ignore the abort we triggered ourselves
      if (error.name !== "AbortError") {
        console.error("Search failed:", error);
        this.renderMessage("Something went wrong. Please try again.");
      }
    }
  }

  renderResults(products, term) {
    if (!products.length) {
      this.renderMessage(`No products found for “${this.escape(term)}”`);
      return;
    }

    const items = products.map((product) => this.productItem(product)).join("");

    const viewAll = `
      <a
        class="search-box__view-all"
        href="${this.searchUrl}?q=${encodeURIComponent(term)}&type=product"
      >View all results</a>`;

    // this.results.innerHTML = `<ul class="search-box__list">${items}</ul>${viewAll}`;
    this.results.innerHTML = `<ul class="search-box__list">${items}</ul>`;
    this.showResults();
  }

  productItem(product) {
    const image =
      (product.featured_image && product.featured_image.url) ||
      product.image ||
      "";

    const title = this.escape(product.title);
    const price = this.formatMoney(product.price_min);

    const thumb = image
      ? `<img src="${image}" alt="${title}" loading="lazy" width="56" height="56">`
      : "";

    return `
      <li class="search-box__item">
        <a class="search-box__link" href="${product.url}">
          <span class="search-box__thumb">${thumb}</span>
          <span class="search-box__meta">
            <span class="search-box__name">${title}</span>
            <span class="search-box__price">${price}</span>
          </span>
        </a>
      </li>`;
  }

  renderMessage(message) {
    this.results.innerHTML = `<p class="search-box__message">${message}</p>`;
    this.showResults();
  }

  showResults() {
    this.results.classList.add("is-visible");
  }

  hideResults() {
    this.results.classList.remove("is-visible");
  }

  // escape user / product text before injecting it into innerHTML
  escape(string) {
    const div = document.createElement("div");
    div.textContent = string ?? "";
    return div.innerHTML;
  }

  // predictive search returns prices in cents; format with the shop's money format
  formatMoney(cents) {
    if (cents == null) return "";
    if (typeof cents === "string") cents = cents.replace(".", "");

    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const format = this.moneyFormat;

    const formatWithDelimiters = (
      number,
      precision = 2,
      thousands = ",",
      decimal = ".",
    ) => {
      if (isNaN(number) || number == null) return "0";

      number = (number / 100).toFixed(precision);

      const parts = number.split(".");
      const dollars = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        "$1" + thousands,
      );
      const centsPart = parts[1] ? decimal + parts[1] : "";

      return dollars + centsPart;
    };

    let value = "";

    switch (format.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return format.replace(placeholderRegex, value);
  }
}

document.querySelectorAll("[data-search-box]").forEach((box) => {
  new SearchBox(box);
});

// ----------------------- Tabs (cart related carousel) -----------------------
// Pairs each tab (data-tab-N) with its panel (data-tab-container-N) by the
// number suffix, so the DOM order of the tabs doesn't matter.
// Sizing is left to CSS in `em`, so changing the container's font-size scales
// the whole component — this class never sets a font-size inline.

class Tabs {
  constructor(tabsEl) {
    this.tabsEl = tabsEl;

    // tabs and panels are siblings, so look in the shared parent
    this.container = tabsEl.parentElement.querySelector(
      "[data-tabs-container]",
    );

    if (!this.container) return;

    this.tabs = this.collect(tabsEl, /^data-tab-(\d+)$/);
    this.panels = this.collect(this.container, /^data-tab-container-(\d+)$/);

    this.init();
  }

  // build a Map of "number suffix" -> element, e.g. "1" -> <span data-tab-1>
  collect(scope, pattern) {
    const map = new Map();

    [...scope.children].forEach((child) => {
      for (const attr of child.attributes) {
        const match = attr.name.match(pattern);

        if (match) {
          map.set(match[1], child);
          break;
        }
      }
    });

    return map;
  }

  init() {
    this.tabs.forEach((tab, key) => {
      tab.addEventListener("click", () => this.activate(key));
    });

    // open the lowest-numbered tab first
    const firstKey = [...this.tabs.keys()].sort((a, b) => a - b)[0];

    if (firstKey) this.activate(firstKey);
  }

  activate(key) {
    this.tabs.forEach((tab, tabKey) => {
      tab.classList.toggle("is-active", tabKey === key);
    });

    this.panels.forEach((panel, panelKey) => {
      const isActive = panelKey === key;

      panel.classList.toggle("is-active", isActive);
      panel.hidden = !isActive;
    });
  }
}

document.querySelectorAll("[data-tabs]").forEach((tabs) => {
  new Tabs(tabs);
});

// ----------------------- Hamburger Sidebar -----------------------

class HamburgerSidebar {
  constructor() {
    this.sidebar = document.querySelector("[data-hamburger-sidebar]");

    if (!this.sidebar) return;

    this.slide = this.sidebar.querySelector(".hamburger-slide");
    this.openButtons = document.querySelectorAll("[data-hamburger-open]");

    this.init();
  }

  init() {
    this.openButtons.forEach((button) => {
      button.addEventListener("click", () => this.toggle());
    });

    // close when clicking the overlay (outside the slide panel)
    this.sidebar.addEventListener("click", (event) => {
      if (this.slide && !this.slide.contains(event.target)) {
        this.close();
      }
    });

    // close on Escape
    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") this.close();
    });
  }

  toggle() {
    if (this.sidebar.classList.contains("hamburger-active")) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.sidebar.classList.add("hamburger-active");
    document.body.classList.add("overflow-hidden");
  }

  close() {
    this.sidebar.classList.remove("hamburger-active");
    document.body.classList.remove("overflow-hidden");
  }
}

new HamburgerSidebar();
